__webpack_require__.p = "/projects/2026/dallas-texas-primary-election-results/";